import React from "react";
import { Constants } from "../../CommonMethhods/Constants";
import { splitDate } from "../../CommonMethhods/CommonMethods";

function PlTable(props) {
  const { data, seg, totalValues, handleScripModal } = props;
  const userType = localStorage.getItem("partnerType").toLowerCase();

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper">
        <table className="table last-column">
          {(seg === "eq" || seg === "eqmf") ? (
            <thead>
              <tr>
                <th scope="col">{Constants.Symbol}</th>
                <th scope="col">ISIN</th>
                {userType !== "partner" ?
                  <>
                    <th scope="col" className="text-center">Buy Qty</th>
                    <th scope="col" className="text-center">Buy Avg</th>
                    <th scope="col" className="text-center">Buy Amount</th>
                    <th scope="col" className="text-center">Sell Qty</th>
                    <th scope="col" className="text-center">Sell Avg</th>
                    <th scope="col" className="text-center">Sell Amount</th>
                  </>
                  : null
                }
                <th scope="col" className="text-center">
                  Net Qty
                </th>
                <th scope="col" className="text-center">
                  Avg Price
                </th>
                <th scope="col" className="text-center">
                  {Constants.Current_Price}
                </th>
                <th scope="col" className="text-center">
                  Investment Amt
                </th>
                <th scope="col" className="text-center">
                  Current Amt
                </th>
                <th scope="col" className="text-center">
                  Realized Pnl
                </th>
                <th scope="col" className="text-center">
                  Realized Gain/Loss(%)
                </th>

                <th scope="col" className="text-center">
                  Unrealized Pnl
                </th>
                <th scope="col" className="text-center">
                  Unrealized Gain/Loss(%)
                </th>
                <th scope="col" className="text-center">
                  Total Pnl
                </th>

                <th scope="col" className="text-center">
                  XIRR %
                </th>
              </tr>
            </thead>
          ) : seg === "mf" ? (
            <thead>
              <tr>
                <th scope="col">{Constants.Symbol}</th>
                <th scope="col" className="text-center">
                  ISIN
                </th>
                <th scope="col" className="text-center">
                  Net Qty
                </th>
                <th scope="col" className="text-center">
                  Current Val
                </th>
                <th scope="col" className="text-center">
                  {Constants.Current_Price}
                </th>
                <th scope="col" className="text-center">
                  Avg Price
                </th>
                <th scope="col" className="text-center">
                  Investment Amt
                </th>
                <th scope="col" className="text-center">
                  Unrealized Pnl
                </th>
                <th scope="col" className="text-center">
                  Unrealized Gain/Loss(%)
                </th>
                <th scope="col" className="text-center">
                  Realized Pnl
                </th>
                <th scope="col" className="text-center">
                  Realized Gain/Loss(%)
                </th>
                <th scope="col" className="text-center">
                  {/* {Constants.Total_PNL_Amount} */}
                  Total Pnl
                </th>
              </tr>
            </thead>
          ) : seg === "fo" || seg === "com" ? (
            <thead>
              <tr>
                <th scope="col">{Constants.Symbol}</th>
                <th scope="col" className="text-center">Inst Type</th>
                <th scope="col" className="text-center">Expiry Date</th>
                <th scope="col" className="text-center">{Constants.Strike_Price}</th>
                <th scope="col" className="text-center">{Constants.Option_Type}</th>
                <th scope="col" className="text-center">Buy Qty</th>
                <th scope="col" className="text-center">Buy Rate</th>
                <th scope="col" className="text-center">Sell Qty</th>
                <th scope="col" className="text-center">Sell Rate</th>
                <th scope="col" className="text-center">Net Qty</th>
                <th scope="col" className="text-center">Closed Price</th>
                <th scope="col" className="text-center">Unrealized Pnl</th>
                <th scope="col" className="text-center">Realized Pnl</th>
                <th scope="col" className="text-center">Total Pnl</th>
              </tr>
            </thead>
          ) : seg === "curfo" ? (
            <thead>
              <tr>
                <th scope="col">{Constants.Symbol}</th>
                <th scope="col" className="text-center">Inst Type</th>
                <th scope="col" className="text-center">{Constants.Option_Type}</th>
                <th scope="col" className="text-center">Expiry Date</th>
                <th scope="col" className="text-center">{Constants.Strike_Price}</th>
                <th scope="col" className="text-center">Net Qty</th>
                <th scope="col" className="text-center">Buy Rate</th>
                <th scope="col" className="text-center">Buy Qty</th>
                <th scope="col" className="text-center">Sell Rate</th>
                <th scope="col" className="text-center">Sell Qty</th>
                <th scope="col" className="text-center">Unrealized Pnl</th>
                <th scope="col" className="text-center">Realized Pnl</th>
                <th scope="col" className="text-center">Total Pnl</th>
              </tr>
            </thead>
          ) : (
            ""
          )}

          <tbody>
            {seg === "fo" || seg === "com"
              ? data.map((item, key) => {
                return (
                  <tr key={key}>
                    <td className={`${item?.symbol?.length > 0 ? "add-color" : "" }`}
                      onClick={()=> item?.symbol?.length > 0 &&
                      handleScripModal("grid", "", item?.symbol, item?.instType, item?.optionType, item?.strikePrice, splitDate(item?.expiryDate))}>
                      {item?.symbol || "-"}</td>
                    <td>{item?.instType || "-"}</td>
                    <td>{item?.expiryDate ? splitDate(item?.expiryDate) : "-"}</td>
                    <td>{item?.strikePrice || 0}</td>
                    <td>{item?.optionType || "-"}</td>
                    <td>{item?.buyQty || 0}</td>
                    <td>{item?.buyRate || 0}</td>
                    <td>{item?.sellQty || 0}</td>
                    <td>{item?.sellRate || 0}</td>
                    <td>{item?.netQty || 0}</td>
                    <td>{item?.closedPrice || 0}</td>
                    <td>{item?.unrealisedPnl || 0}</td>
                    <td>{item?.realised || 0}</td>
                    <td>{item?.totalPnl || 0}</td>
                  </tr>
                );
              })
              : seg === "curfo"
              ? data.map((item, key) => {
                return (
                  <tr key={key}>
                    <td>{item?.symbol || "-"}</td>
                    <td>{item?.instType || "-"}</td>
                    <td>{item?.optionType || "-"}</td>
                    <td>{item?.expiryDate ? splitDate(item?.expiryDate) : "-"}</td>
                    <td>{item?.strikePrice || 0}</td>
                    <td>{item?.netQty || 0}</td>
                    <td>{item?.buyRate || 0}</td>
                    <td>{item?.buyQty || 0}</td>
                    <td>{item?.sellRate || 0}</td>
                    <td>{item?.sellQty || 0}</td>
                    <td>{item?.unrealisedPnl || 0}</td>
                    <td>{item?.realised || 0}</td>
                    <td>{item?.totalPnl || 0}</td>
                  </tr>
                );
              })
              : (seg === "eq" || seg === "eqmf")
                ? data.map((item, key) => {
                  return (
                    <tr key={key}>
                      {seg === "eqmf" ?
                      <td>{item?.scripName || "-"}</td>
                    :
                      <td className={`${item?.scripName?.length > 0 ? "add-color" : "" }`} 
                      onClick={()=> item?.scripName?.length > 0 && handleScripModal("grid", item?.isin, "", "", "", 0, "")}>{item?.scripName || "-"}</td>
                    }
                      <td>{item?.isin || "-"}</td>
                      {userType !== "partner" ? <>
                        <td>{item?.buyQty || 0}</td>
                        <td>{item?.buyAvg || 0}</td>
                        <td>{item?.buyAmt || 0}</td>
                        <td>{item?.sellQty || 0}</td>
                        <td>{item?.sellAvg || 0}</td>
                        <td>{item?.sellAmt || 0}</td>

                      </>
                        : null}
                      <td>{item?.netQty || 0}</td>
                      <td>{item?.avgPrice || 0}</td>
                      <td>{item?.currentPrice || 0}</td>
                      <td>{item?.invetmentAMT || 0}</td>
                      <td>{item?.currentAMT || 0}</td>
                      <td>{item?.releasedPNL || 0}</td>
                      <td>{item?.releasedPNLPercentage || 0}</td>
                      <td>{item?.unreleasedPNL || 0}</td>
                      <td>{item?.unreleasedPNLPercentage || 0}</td>
                      <td>{item?.totalPNL || 0}</td>
                      <td>{item?.xirr || 0}</td>
                    </tr>
                  );
                })
                : seg === "mf"
                  ? data.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>
                          {item?.scripName || "-"}</td>
                        <td>{item?.isIn || "-"}</td>
                        <td>{item?.netQty || 0}</td>
                        <td>{item?.currentAMT || 0}</td>
                        <td>{item?.currentPrice || 0}</td>
                        <td>{item?.avgPrice || 0}</td>
                        <td>{item?.invetmentAMT || 0}</td>
                        <td>{item?.unreleasedPNL || 0}</td>
                        <td>{item?.unreleasedPNLPercentage || 0}</td>
                        <td>{item?.releasedPNL || 0}</td>
                        <td>{item?.releasedPNLPercentage || 0}</td>
                        <td>{item?.totalPNL || 0}</td>
                      </tr>
                    );
                  })
                  : ""}
          </tbody>
          {(seg === "eq" || seg === "eqmf") && (
            <tbody className="tax-total-values">
              <tr>
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                {
                  userType != "partner" ?
                    <>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </>
                    : null
                }
                <td>{totalValues.totalInvstmntAmt || 0}</td>
                <td>{totalValues.totalCurrentAmt || 0}</td>
                <td>{totalValues.totalRealizedPnl || 0}</td>
                <td></td>
                <td>{totalValues.totalUnrealizedPnl || 0}</td>
                <td></td>
                <td>{totalValues.totalPnl || 0}</td>
                <td></td>
              </tr>
            </tbody>
          )}
          {seg === "mf" && (
            <tbody className="tax-total-values">
              <tr>
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{totalValues.totalUnrealizedPnl || 0}</td>
                <td></td>
                <td>{totalValues.totalRealizedPnl || 0}</td>
                <td></td>
                <td>{totalValues.totalPnl || 0}</td>
              </tr>
            </tbody>
          )}
          {(seg === "fo" || seg === "curfo") && (
            <tbody className="tax-total-values">
              <tr>
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{totalValues.totalUnrealizedPnl || 0}</td>
                <td>{totalValues.totalRealizedPnl || 0}</td>
                <td>{totalValues.totalPnl || 0}</td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </>
  );
}
export default PlTable;
